var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGenerate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "planilla_main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_174",
    "data-name": "Rect\\xE1ngulo 174",
    width: 15,
    height: 15,
    fill: "#85af26",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_2",
    "data-name": "Enmascarar grupo 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67",
    transform: "translate(3.529 2.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48",
    "data-name": "Trazado 48",
    d: "M18.95,65.109V66.39h3.388v-.112c0-.289,0-1.02,0-1.309,0-.147.062-.211.2-.211h1.395c.141,0,.2.061.205.2,0,1.189,0,3.7,0,4.89,0,.148-.068.2-.234.2H18.816c-.164,0-.224-.06-.224-.225,0-1.175,0-3.673,0-4.848,0-.161.058-.22.216-.22h2.779c.142,0,.218.062.218.175s-.077.176-.219.176H18.95Zm4.833,4.583V65.117H22.7V66.4c.157,0,.309-.01.458.005a.222.222,0,0,1,.154.108.207.207,0,0,1-.031.175.224.224,0,0,1-.154.06c-.143.008-.286,0-.426,0v1.309c.154,0,.3,0,.448,0a.175.175,0,0,1,.184.17.179.179,0,0,1-.176.18c-.048,0-.1,0-.145,0h-.319c0,.123,0,.23,0,.337a.177.177,0,1,1-.351,0c0-.109,0-.218,0-.327H18.952v1.275ZM18.95,68.05h3.383V66.755H18.95Z",
    transform: "translate(-17.314 -61.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49",
    "data-name": "Trazado 49",
    d: "M20.017,46.243h1.147a.819.819,0,0,1,.093,0,.172.172,0,0,1,.033.336.411.411,0,0,1-.122.014h-2.3a.61.61,0,0,1-.082,0,.173.173,0,0,1-.164-.189.166.166,0,0,1,.18-.16c.406,0,.813,0,1.219,0Z",
    transform: "translate(-17.337 -43.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50",
    "data-name": "Trazado 50",
    d: "M8.108,2.174c0-.021,0-.041,0-.062a.186.186,0,0,0-.054-.118h0c-.006-.02-.032-.035-.049-.052L6.059,0H.6C.165.152,0,.355,0,.751Q0,5.3,0,9.839a.7.7,0,0,0,.751.749h6.6a.948.948,0,0,0,.154-.008.7.7,0,0,0,.6-.727c0-2.233,0-5.445,0-7.678m-.687-.319c.023.023.044.048.081.088a1.057,1.057,0,0,0,.073.08H6.188a.13.13,0,0,1-.13-.13V.488q.68.685,1.364,1.367m-.07,8.381H.759A.359.359,0,0,1,.352,9.83q0-4.534,0-9.067A.36.36,0,0,1,.766.353q2.474,0,4.948,0V1.893a.474.474,0,0,0,.474.474H7.756c0,2.2,0,5.3,0,7.46a.359.359,0,0,1-.4.408",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGenerate);
export default __webpack_public_path__ + "static/media/icon_generate.5ba3ae31633d12c159b06672fa21d639.svg";
export { ForwardRef as ReactComponent };